// Admin Support → support-bundle generator API client (item 100
// Phase B of PRODUCT-ROADMAP.md). Backs the AdminSupport page.
//
// /api/admin/support/generate-bundle streams a tar.gz back. We can't
// route that through SWR — instead the page hits this helper, which
// does fetch + Blob → object-URL → click-the-anchor so the file lands
// on disk with the Content-Disposition filename the server proposes.

export const SUPPORT_SECTIONS = [
  'logs',
  'metrics',
  'config',
  'deployment',
  'db-stats',
  'observability',
] as const;

export type SupportSection = (typeof SUPPORT_SECTIONS)[number];

export interface GenerateBundleInput {
  since_hours: number;
  include: SupportSection[];
}

export interface GenerateBundleResult {
  filename: string;
  size: number;
}

export async function generateSupportBundle(
  input: GenerateBundleInput,
): Promise<GenerateBundleResult> {
  const res = await fetch('/api/admin/support/generate-bundle', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      since_hours: input.since_hours,
      include: input.include,
    }),
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`${res.status}: ${body || res.statusText}`);
  }
  const cd = res.headers.get('Content-Disposition') ?? '';
  const m = /filename="([^"]+)"/.exec(cd);
  const filename = m
    ? m[1]
    : `orbitalreg-diag-${new Date()
        .toISOString()
        .replace(/[-:]/g, '')
        .replace(/\.\d+Z$/, 'Z')}.tar.gz`;
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return { filename, size: blob.size };
}
